
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { store, StoreMutations } from '@/store';
import { FilterCampionarioProduzione } from '@/models';

@Component
export default class OpzioniLavorazioniComandi extends Vue {    

    get bottoneAzioniVisibile(): boolean {
        return this.$store.state.listaLavorazioniSelezionate.length > 0;
    }

    get filtriApplicati(): boolean {
        let applicati = store.state.uiLavorazioni.filtri.filtroModelli.length > 0;
        applicati = applicati || store.state.uiLavorazioni.filtri.filtroStagioni.length > 0;
        applicati = applicati || store.state.uiLavorazioni.filtri.filtroFasi.length > 0;
        applicati = applicati || (store.state.uiLavorazioni.filtri.filtroConsegne || []).length > 0;
        applicati = applicati || store.state.uiLavorazioni.filtri.numOrdine.length > 0;
        applicati = applicati || store.state.uiLavorazioni.filtri.codLAK.length > 0;
        applicati = applicati || store.state.uiLavorazioni.filtri.soloUSA;
        applicati = applicati || store.state.uiLavorazioni.filtri.soloConNote;
        applicati = applicati || store.state.uiLavorazioni.filtri.campionarioEProduzione != FilterCampionarioProduzione.CampionarioEProduzione;
        applicati = applicati || (store.state.uiLavorazioni.filtri.lotto?.length ?? 0) > 0;

        return applicati;
    }

    get toggleViewIcon(): string {
        return store.state.uiLavorazioni.listView ? 'mdi-apps' : 'mdi-format-list-bulleted';
    }

    private toggleView(): void {
        store.commit(StoreMutations.LavorazioniUiToggleListView);
    }

    private mostraOpzioni(): void {
        store.commit(StoreMutations.SetOpzioniVisibili, true);
    }

    private mostraAzioni(): void {
        store.commit(StoreMutations.SetAzioniVisibili);
    }
}
